import { render, staticRenderFns } from "./ktgl-learning-lock.vue?vue&type=template&id=34fa5fe8"
import script from "./ktgl-learning-lock.vue?vue&type=script&lang=ts"
export * from "./ktgl-learning-lock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports